// src/pages/checkout/ConfirmPage.jsx
import React from "react";
import { Paper, Typography, Stack } from "@mui/material";
import { useCheckout } from "./CheckoutContext";

export default function ConfirmPage() {
  const { cartItems, address, payment } = useCheckout();
  const total = cartItems.reduce((s, it) => s + it.price * it.qty, 0);

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>訂單確認</Typography>

      <Typography sx={{ mt: 1, fontWeight: 600 }}>金額：{total.toLocaleString()} 円（未稅）</Typography>

      <Stack sx={{ mt: 2 }}>
        <Typography variant="subtitle2">收件資訊</Typography>
        <Typography variant="body2" color="text.secondary">
          {address.receiver}｜{address.phone}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {address.zip} {address.city} {address.street}
        </Typography>
      </Stack>

      <Stack sx={{ mt: 2 }}>
        <Typography variant="subtitle2">付款方式</Typography>
        <Typography variant="body2" color="text.secondary">
          {payment.method === "card"
            ? `信用卡（末四碼 ${payment.cardLast4 || "----"}）`
            : payment.method === "cod" ? "貨到付款" : "銀行轉帳"}
        </Typography>
      </Stack>
    </Paper>
  );
}
